import React from 'react';
import { useHistory } from 'react-router-dom';
import './style.scss';

export const InternalServerError = props => {
  const error: any = props.error;
  const history = useHistory();
  const goToPreviousPath = () => {
    window.location.reload();
    // window.location.href = document.referrer;
    // history.goBack()
  };

  return (
    <>
      <div className="error-page">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <p className="error-page-title">Oups, une erreur s&apos;est produite. </p>
            <p className="error-page-subtitle">Veuillez rafraîchir la page ou réessayer un peu plus tard.</p>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-6">
            <img className="align-middle" src="content/images/illu_oups.svg" />
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-6">
            <p className="_text">Merci de bien vouloir nous excuser.</p>
            <a style={{ textDecoration: 'underline' }} onClick={goToPreviousPath}>
              Retour
            </a>
          </div>
        </div>
        {process.env.NODE_ENV === 'development' ? (
          <>
            <br />
            <p className="_message">{error?.type}</p>
            <br />
            {error?.message}
            <br />
            <ul className="_details_error">
              {error?.details?.map((e, i) => {
                return <li key={i}>{e}</li>;
              })}
            </ul>
          </>
        ) : undefined}
      </div>
    </>
  );
};

export default InternalServerError;
